import { mailRegex, telRegex } from '../../../regex';

export const formAccountDetailsSchema = {
  firstname: {
    presence: {
      allowEmpty: false,
      message: '^Ce champ est requis'
    }
  },
  lastname: {
    presence: { allowEmpty: false, message: '^Ce champ est requis' }
  },
  email: {
    presence: { allowEmpty: false, message: '^Ce champ est requis' },
    format: {
      pattern: mailRegex,
      message: '^Veuillez entrer un mail valide'
    }
  },
  tel: {
    presence: { allowEmpty: false, message: 'Ce champ est requis' },
    length: {
      is: 10,
      message: `Le numéro de téléphone doit contenir 10 chiffres.`
    },
    format: {
      pattern: telRegex,
      message: 'Vous devez renseigner un numéro de téléphone'
    }
  }
};
